export const GREY42 = 'rgb(107,107,107)';
export const PLATINUM = 'rgb(242, 242, 242)';
export const ACTIVEGREEN = 'rgb(0, 153, 51)';
export const ALTO = 'rgb(215, 215, 215)';
export const HOVERBLUE = 'rgb(22, 50, 92)';
export const WHITE = 'rgb(255,255,255)';
export const CHARCOAL = 'rgb(89,89,89)';
export const DOVEGREY = 'rgb(102,102,102)';
export const LIGHTGREY = 'rgb(211,211,211)';
export const HRLINEGREY = 'rgb(204,204,204)';
export const BLACK = 'rgb(0,0,0)';
export const BLUE = 'rgb(74,161,207)';
export const DARKGREEN = 'rgb(22, 66, 56)';
export const RED = 'rgb(216, 65, 28)';
export const POWDER = 'rgb(229, 241, 247)';
export const DARKGREY = 'rgb(182, 182, 182)';



// WEBPACK FOOTER //
// ./src/theme/color.js